var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.disabled)?[_vm._t("default")]:[_c('b-tooltip',{attrs:{"label":_vm.label,"position":_vm.position}},[_vm._t("default")],2)]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }